import React, { useState, CSSProperties } from 'react'
import api from '@api'
import { Collapse, H6, Position, Menu, MenuItem, Switch, MenuDivider } from '@blueprintjs/core'
import { Popover } from '@ui'
import { IconButton, FilterButton, FilterContainer, Icon, MultiLocationSelect } from '@ui'
import APWidget from 'components/APWidget'
import { IPortfolio } from './hooks/usePortfolio'
import { Nav } from '@utils'
import { useFileDownload } from '@hooks'
import track from '@track'
import css from './filters.module.scss'
interface IProps {
  hook: IPortfolio
  setIsOpen: (param: boolean) => void
  isOpen: boolean
}
export default function Filters({ hook, setIsOpen, isOpen }: IProps) {
  const startFileDownload = useFileDownload()

  return (
    <div
      className={css.filter}
      style={{
        height: isOpen ? 183 : 55,
      }}
    >
      <div className="f mb3 printhide">
        <FilterButton
          filterCount={hook.filterCount()}
          onClick={() => setIsOpen(!isOpen)}
          onClear={() => {
            hook.clearFilters()
            track.portfolio({ eventName: track.Event.CLEAR_ALL_FILTERS })
          }}
        />
        <Popover
          className="mla"
          content={<MoreMenu hook={hook} startFileDownload={startFileDownload} />}
          position={Position.BOTTOM}
          minimal
        >
          <IconButton tooltip="More actions" iconName="ellipsis-h" round={false} />
        </Popover>
      </div>
      <Collapse isOpen={isOpen}>
        <div className="f mb3">
          <FilterContainer>
            <H6>Assignment Plan</H6>
            <APWidget
              readonly={true}
              value={hook.assignmentPlanId}
              onChange={(ap) => {
                track.portfolio({
                  eventName: track.Event.FILTER,
                  props: {
                    filterName: 'Assignment Plan',
                    filterValue: ap.name,
                  },
                })
                Nav.portfolio({ apId: ap.id })
                hook.setAssignmentPlanId(ap)
              }}
            />
          </FilterContainer>
          <FilterContainer>
            <MultiLocationSelect
              mode={MultiLocationSelect.Mode.MULTI_REGION_CITY_BUILDING}
              values={hook.filteredLocations}
              includeOldBuildings={hook.showInactiveBuildings}
              onChange={(newSelection) => {
                track.portfolio({
                  eventName: track.Event.FILTER,
                  props: {
                    filterName: 'Locations',
                    filterValue: newSelection.map((s: any) => s.name).filter((n: any) => n),
                  },
                })
                hook.setFilteredLocations(newSelection)
              }}
            />
          </FilterContainer>
          <FilterContainer>
            <H6>Show Inactive Buildings</H6>
            <Switch
              style={switchStyle}
              checked={hook.showInactiveBuildings}
              onChange={(e: any) => {
                track.portfolio({
                  eventName: track.Event.FILTER,
                  props: {
                    filterName: 'Show Inactive Buildings',
                    filterValue: e.target.checked,
                  },
                })
                hook.setShowInactiveBuildings(e.target.checked)
              }}
            />
          </FilterContainer>
        </div>
      </Collapse>
    </div>
  )
}

const switchStyle: CSSProperties = {
  width: 38,
}

function MoreMenu({
  hook,
  startFileDownload,
}: {
  hook: IPortfolio
  startFileDownload: (to: string) => void
}) {
  const { assignmentPlanId, filteredLocations } = hook
  const citiesFromLocations = filteredLocations.reduce<string[]>((acc, filtLoc) => {
    if ('cities' in filtLoc) return acc
    return [...acc, filtLoc.name]
  }, [])

  return (
    <Menu>
      <MenuItem
        text="Print / Save as PDF"
        icon={<Icon style={{ marginTop: 2 }} name="print" />}
        onClick={() => {
          track.portfolio({ eventName: track.Event.PRINT })
          window.print()
        }}
      />
      <MenuItem
        text="Export to CSV"
        icon={<Icon style={{ marginTop: 2 }} name="download" />}
        onClick={() => {
          track.portfolio({ eventName: track.Event.EXPORT })
          api.portfolio
            .exportCSV({
              assignmentPlanId,
              cities: citiesFromLocations,
            })
            .then(({ data }) => {
              startFileDownload(data.viewer.company.portfolio.export)
            })
        }}
      />
      <MenuDivider />
      <MenuItem
        text="Building management"
        icon={<Icon style={{ marginTop: 2 }} name="building" />}
        onClick={() => Nav.buildingManagement({})}
      />
    </Menu>
  )
}
